import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./Layout.jsx"



function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
